var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.59,
    height: 30.723,
    viewBox: "0 0 30.59 30.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-button",
    transform: "translate(-0.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40908",
    "data-name": "Path 40908",
    d: "M115.42,1.035,115.383,1a3.828,3.828,0,0,0-5.408.245L96.295,16.224a1.32,1.32,0,0,0-.278.473l-1.609,4.822a1.834,1.834,0,0,0,1.737,2.414h0a1.827,1.827,0,0,0,.736-.155l4.658-2.038a1.32,1.32,0,0,0,.446-.319L115.665,6.444A3.833,3.833,0,0,0,115.42,1.035ZM97.49,20.628l.944-2.83.08-.087,1.789,1.634-.08.087ZM113.715,4.662l-11.63,12.733L100.3,15.761l11.63-12.733a1.186,1.186,0,0,1,1.676-.075l.037.034A1.188,1.188,0,0,1,113.715,4.662Z",
    transform: "translate(-85.318)",
    fill: "#279989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40909",
    "data-name": "Path 40909",
    d: "M27.448,41.611a1.321,1.321,0,0,0-1.321,1.321V54.147a3.363,3.363,0,0,1-3.359,3.359H6.758A3.363,3.363,0,0,1,3.4,54.147V38.267a3.363,3.363,0,0,1,3.359-3.359H18.346a1.321,1.321,0,0,0,0-2.642H6.758a6.008,6.008,0,0,0-6,6V54.146a6.008,6.008,0,0,0,6,6H22.768a6.008,6.008,0,0,0,6-6V42.932A1.321,1.321,0,0,0,27.448,41.611Z",
    transform: "translate(0 -29.425)",
    fill: "#279989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/editButton.d1dfc1d6.svg";
export { ForwardRef as ReactComponent };